// AUTO-GENERATED by tools/gen-daily-boss-table.ts — do not edit.
// Compact projection of generated/mon.ts for the daily-boss derivation. Kept separate from
// mon.ts so belch can run the identical derivation without the whole catalog; both repos read
// this file, so there is one source and no drift.

export type DailyBossMoveClass = 'phys' | 'spec' | 'other' | 'self';

export interface DailyBossMove {
  /** Catalog lane — the bit this move occupies in a phantom team's moveSelections byte. */
  readonly lane: number;
  readonly name: string;
  readonly type: number;
  readonly stamina: number;
  /** Variable moves report power 60 / stamina 2 rather than '?'. */
  readonly power: number;
  readonly variable: boolean;
  readonly cls: DailyBossMoveClass;
}

export interface DailyBossMon {
  readonly id: number;
  readonly name: string;
  readonly type1: number;
  readonly type2: number | null;
  readonly hp: number;
  readonly attack: number;
  readonly defense: number;
  readonly specialAttack: number;
  readonly specialDefense: number;
  readonly speed: number;
  readonly moves: readonly DailyBossMove[];
}

export const DAILY_BOSS_TABLE: readonly DailyBossMon[] = [
  {
    id: 0, name: "Ghouliath",
    type1: 0, type2: 4,
    hp: 303, attack: 157, defense: 202,
    specialAttack: 151, specialDefense: 202, speed: 181,
    moves: [
    { lane: 0, name: "Eternal Grudge", type: 0, stamina: 2, power: 0, variable: false, cls: 'self' },
    { lane: 1, name: "Infernal Flame", type: 4, stamina: 2, power: 120, variable: false, cls: 'spec' },
    { lane: 2, name: "Wither Away", type: 0, stamina: 3, power: 60, variable: false, cls: 'spec' },
    { lane: 3, name: "Osteoporosis", type: 0, stamina: 2, power: 90, variable: false, cls: 'phys' },
    { lane: 4, name: "Grave Affliction", type: 0, stamina: 2, power: 0, variable: false, cls: 'other' },
    ],
  },
  {
    id: 1, name: "Inutia",
    type1: 9, type2: null,
    hp: 351, attack: 171, defense: 189,
    specialAttack: 175, specialDefense: 192, speed: 229,
    moves: [
    { lane: 0, name: "Chain Expansion", type: 9, stamina: 1, power: 0, variable: false, cls: 'other' },
    { lane: 1, name: "Initialize", type: 9, stamina: 2, power: 0, variable: false, cls: 'self' },
    { lane: 2, name: "Big Bite", type: 9, stamina: 2, power: 80, variable: false, cls: 'phys' },
    { lane: 3, name: "Hit And Dip", type: 9, stamina: 2, power: 60, variable: false, cls: 'spec' },
    { lane: 4, name: "Sanctify", type: 9, stamina: 2, power: 0, variable: false, cls: 'other' },
    ],
  },
  {
    id: 2, name: "Malalien",
    type1: 12, type2: null,
    hp: 258, attack: 121, defense: 125,
    specialAttack: 322, specialDefense: 151, speed: 308,
    moves: [
    { lane: 0, name: "Triple Think", type: 11, stamina: 2, power: 0, variable: false, cls: 'self' },
    { lane: 1, name: "Federal Investigation", type: 12, stamina: 3, power: 100, variable: false, cls: 'spec' },
    { lane: 2, name: "Negative Thoughts", type: 11, stamina: 3, power: 80, variable: false, cls: 'spec' },
    { lane: 3, name: "Infinite Love", type: 13, stamina: 3, power: 90, variable: false, cls: 'spec' },
    { lane: 4, name: "Foul Language", type: 12, stamina: 2, power: 60, variable: false, cls: 'spec' },
    ],
  },
  {
    id: 3, name: "Iblivion",
    type1: 1, type2: 10,
    hp: 277, attack: 199, defense: 164,
    specialAttack: 180, specialDefense: 168, speed: 256,
    moves: [
    { lane: 0, name: "Unbounded Strike", type: 10, stamina: 2, power: 60, variable: true, cls: 'phys' },
    { lane: 1, name: "Loop", type: 1, stamina: 1, power: 0, variable: false, cls: 'self' },
    { lane: 2, name: "Brightback", type: 1, stamina: 2, power: 70, variable: false, cls: 'phys' },
    { lane: 3, name: "Renormalize", type: 1, stamina: 0, power: 0, variable: false, cls: 'self' },
    ],
  },
  {
    id: 4, name: "Gorillax",
    type1: 2, type2: null,
    hp: 407, attack: 302, defense: 175,
    specialAttack: 112, specialDefense: 176, speed: 129,
    moves: [
    { lane: 0, name: "Rock Pull", type: 2, stamina: 3, power: 60, variable: true, cls: 'phys' },
    { lane: 1, name: "Pound Ground", type: 2, stamina: 3, power: 95, variable: false, cls: 'phys' },
    { lane: 2, name: "Blow", type: 10, stamina: 2, power: 70, variable: false, cls: 'phys' },
    { lane: 3, name: "Throw Pebble", type: 2, stamina: 1, power: 40, variable: false, cls: 'phys' },
    ],
  },
  {
    id: 5, name: "Sofabbi",
    type1: 7, type2: null,
    hp: 333, attack: 180, defense: 201,
    specialAttack: 120, specialDefense: 269, speed: 175,
    moves: [
    { lane: 0, name: "Gachachacha", type: 12, stamina: 3, power: 60, variable: true, cls: 'phys' },
    { lane: 1, name: "Guest Feature", type: 12, stamina: 3, power: 75, variable: false, cls: 'phys' },
    { lane: 2, name: "Unexpected Carrot", type: 7, stamina: 4, power: 120, variable: false, cls: 'phys' },
    { lane: 3, name: "Snack Break", type: 7, stamina: 1, power: 0, variable: false, cls: 'self' },
    ],
  },
  {
    id: 6, name: "Pengym",
    type1: 6, type2: null,
    hp: 371, attack: 212, defense: 191,
    specialAttack: 233, specialDefense: 172, speed: 149,
    moves: [
    { lane: 0, name: "Chill Out", type: 6, stamina: 0, power: 0, variable: false, cls: 'other' },
    { lane: 1, name: "Deadlift", type: 5, stamina: 2, power: 0, variable: false, cls: 'self' },
    { lane: 2, name: "Deep Freeze", type: 6, stamina: 3, power: 90, variable: false, cls: 'phys' },
    { lane: 3, name: "Pistol Squat", type: 5, stamina: 2, power: 80, variable: false, cls: 'phys' },
    ],
  },
  {
    id: 7, name: "Embursa",
    type1: 4, type2: null,
    hp: 420, attack: 141, defense: 220,
    specialAttack: 190, specialDefense: 161, speed: 111,
    moves: [
    { lane: 0, name: "Honey Bribe", type: 7, stamina: 2, power: 0, variable: false, cls: 'self' },
    { lane: 1, name: "Set Ablaze", type: 4, stamina: 3, power: 90, variable: false, cls: 'spec' },
    { lane: 2, name: "Heat Beacon", type: 4, stamina: 0, power: 0, variable: false, cls: 'self' },
    { lane: 3, name: "Q5", type: 4, stamina: 2, power: 150, variable: false, cls: 'spec' },
    ],
  },
  {
    id: 8, name: "Volthare",
    type1: 8, type2: 12,
    hp: 310, attack: 120, defense: 184,
    specialAttack: 255, specialDefense: 176, speed: 311,
    moves: [
    { lane: 0, name: "Electrocute", type: 8, stamina: 2, power: 90, variable: false, cls: 'spec' },
    { lane: 1, name: "Round Trip", type: 8, stamina: 1, power: 30, variable: false, cls: 'spec' },
    { lane: 2, name: "Mega Star Blast", type: 8, stamina: 3, power: 150, variable: false, cls: 'spec' },
    { lane: 3, name: "Dual Shock", type: 12, stamina: 0, power: 60, variable: false, cls: 'spec' },
    { lane: 4, name: "Quickstorm", type: 8, stamina: 2, power: 30, variable: false, cls: 'spec' },
    ],
  },
  {
    id: 9, name: "Aurox",
    type1: 5, type2: null,
    hp: 400, attack: 150, defense: 230,
    specialAttack: 100, specialDefense: 220, speed: 100,
    moves: [
    { lane: 0, name: "Volatile Punch", type: 5, stamina: 3, power: 40, variable: false, cls: 'phys' },
    { lane: 1, name: "Gilded Recovery", type: 9, stamina: 2, power: 0, variable: false, cls: 'self' },
    { lane: 2, name: "Iron Wall", type: 5, stamina: 3, power: 0, variable: false, cls: 'self' },
    { lane: 3, name: "Bull Rush", type: 5, stamina: 2, power: 140, variable: false, cls: 'phys' },
    { lane: 4, name: "Big Bellow", type: 5, stamina: 1, power: 0, variable: false, cls: 'other' },
    ],
  },
  {
    id: 10, name: "Xmon",
    type1: 13, type2: null,
    hp: 311, attack: 123, defense: 179,
    specialAttack: 222, specialDefense: 185, speed: 285,
    moves: [
    { lane: 0, name: "Contagious Slumber", type: 13, stamina: 2, power: 0, variable: false, cls: 'other' },
    { lane: 1, name: "Vital Siphon", type: 13, stamina: 2, power: 40, variable: false, cls: 'spec' },
    { lane: 2, name: "Somniphobia", type: 13, stamina: 1, power: 0, variable: false, cls: 'other' },
    { lane: 3, name: "Old Vengeance", type: 13, stamina: 4, power: 30, variable: false, cls: 'spec' },
    { lane: 4, name: "Invoke Taboo", type: 13, stamina: 1, power: 0, variable: false, cls: 'other' },
    ],
  },
  {
    id: 11, name: "Ekineki",
    type1: 3, type2: null,
    hp: 299, attack: 130, defense: 180,
    specialAttack: 280, specialDefense: 175, speed: 266,
    moves: [
    { lane: 0, name: "Bubble Bop", type: 3, stamina: 3, power: 50, variable: false, cls: 'spec' },
    { lane: 1, name: "Sneak Attack", type: 3, stamina: 2, power: 70, variable: false, cls: 'spec' },
    { lane: 2, name: "Nine Nine Nine", type: 11, stamina: 1, power: 0, variable: false, cls: 'self' },
    { lane: 3, name: "Overflow", type: 11, stamina: 3, power: 90, variable: false, cls: 'spec' },
    ],
  },
  {
    id: 12, name: "Nirvamma",
    type1: 11, type2: null,
    hp: 373, attack: 202, defense: 168,
    specialAttack: 140, specialDefense: 202, speed: 177,
    moves: [
    { lane: 0, name: "Hard Reset", type: 11, stamina: 2, power: 0, variable: false, cls: 'other' },
    { lane: 1, name: "Scary Numbers", type: 11, stamina: 3, power: 80, variable: false, cls: 'phys' },
    { lane: 2, name: "Chronoffense", type: 11, stamina: 2, power: 60, variable: true, cls: 'phys' },
    { lane: 3, name: "Modal Bolt", type: 11, stamina: 3, power: 90, variable: false, cls: 'phys' },
    ],
  },
  {
    id: 13, name: "Glob",
    type1: 3, type2: 9,
    hp: 256, attack: 180, defense: 201,
    specialAttack: 115, specialDefense: 191, speed: 151,
    moves: [
    { lane: 0, name: "Holy Molt", type: 9, stamina: 2, power: 0, variable: true, cls: 'self' },
    { lane: 1, name: "Water Claw", type: 3, stamina: 2, power: 80, variable: false, cls: 'phys' },
    { lane: 2, name: "Holy Water Claw", type: 9, stamina: 3, power: 90, variable: false, cls: 'phys' },
    { lane: 3, name: "Get Slippery", type: 3, stamina: 2, power: 0, variable: false, cls: 'self' },
    ],
  },
  {
    id: 14, name: "Mulong",
    type1: 10, type2: 8,
    hp: 388, attack: 115, defense: 188,
    specialAttack: 288, specialDefense: 138, speed: 212,
    moves: [
    { lane: 0, name: "Summon Storm", type: 8, stamina: 4, power: 0, variable: false, cls: 'other' },
    { lane: 1, name: "Grand Respite", type: 10, stamina: 2, power: 120, variable: false, cls: 'spec' },
    { lane: 2, name: "Thunderclap", type: 8, stamina: 3, power: 120, variable: false, cls: 'spec' },
    { lane: 3, name: "Cloud Strike", type: 6, stamina: 2, power: 60, variable: true, cls: 'spec' },
    ],
  },
];
